import { USBColumn, USBGrid } from "@usb-shield/react-grid";
import classNames from "classnames";
import React from "react";

const ShellGridColumn = ({
  isMultiColumn = true,
  isMultiGrid = false,
  actAsPageHeader,
  contentOnTop,
  actAsPageFooter,
  actAsCardFirstChildd,
  actAsCardLastChild,
  actAsCardMiddleChild,
  removeBottomSpace,
  actAsCardChild,
  actAsShell,
  actAsShellChild,
  showThinBottomMargin,
  showBottomDivider,
  isOnlyCardChild,
  mobileTopMargin,
  mobileBottomMargin,
  desktopTopLeftMargin,
  cardColorTheme,
  gapOnTop,
  gapOnBottom,
  id,
  compact,
  otherProps,
  contentDirection,
  removeSpaceOf,
  hasGridZeroPadding,
  children}
) => {
  if (isMultiColumn) {
    return (
      <USBGrid
        addClasses={classNames(
          ...[
            "usbobp-layout--override-row-gap",
            "usbobp-layout--override-tb-padding",
          ]
        )}
        addContainerClasses={classNames({
          "usbobp-layout--page-header": actAsPageHeader,
          "usbobp-layout--page-footer": actAsPageFooter,
          "usbobp-layout--card-first-child": actAsCardFirstChildd,
          "usbobp-layout--card-last-child": actAsCardLastChild,
          "usbobp-layout--card-middle-child": actAsCardMiddleChild,
          "usbobp-layout--remove-bottom-space": removeBottomSpace,
          "usbobp-layout--card-child": actAsCardChild,
          "usbobp-layout--shell": actAsShell,
          "usbobp-layout--shell-child": actAsShellChild,
          "usbobp-layout--thin-margin": showThinBottomMargin,
          "usbobp-layout--bottom-divider": showBottomDivider,
          "usbobp-layout--card-only-child": isOnlyCardChild,
          "usbobp-layout--mobile-top-margin": mobileTopMargin,
          "usbobp-layout--mobile-bottom-margin": mobileBottomMargin,
          // "usbobp-layout--desktop-topLeft-margin": desktopTopLeftMargin,
          "usbobp-layout--desktop-topLeft-margin-16":
            desktopTopLeftMargin === "16",
          "usbobp-layout--mobile-top-margin-24": mobileTopMargin === "24",
          "usbobp-layout--mobile-top-margin-10": mobileTopMargin === "10",
          "usbobp-layout--mobile-top-margin-8": mobileTopMargin === "8",
          "usbobp-layout--mobile-top-margin-0": mobileTopMargin === "0",
          "usbobp-layout--mobile-bottom-margin-24": mobileBottomMargin === "24",
          "usbobp-layout--mobile-bottom-margin-10": mobileBottomMargin === "10",
          "usbobp-layout--mobile-bottom-margin-8": mobileBottomMargin === "8",
          "usbobp-layout--mobile-bottom-margin-0": mobileBottomMargin === "0",
          // "usbobp-layout--color-theme-white": cardColorTheme === "white",
          "usbobp-layout--color-theme-gray": cardColorTheme === "gray",
          "usbobp-layout--gap-on-top-0": !contentOnTop && gapOnTop === "0",
          "usbobp-layout--gap-on-top-8": !contentOnTop && gapOnTop === "8",
          "usbobp-layout--gap-on-top-16": !contentOnTop && gapOnTop === "16",
          "usbobp-layout--gap-on-top-24": !contentOnTop && gapOnTop === "24",
          "usbobp-layout--gap-on-bottom-0":
            !contentOnTop && gapOnBottom === "0",
          "usbobp-layout--gap-on-bottom-8":
            !contentOnTop && gapOnBottom === "8",
          "usbobp-layout--gap-on-bottom-16":
            !contentOnTop && gapOnBottom === "16",
          "usbobp-layout--gap-on-bottom-24":
            !contentOnTop && gapOnBottom === "24",
          "usbobp-layout--gap-on-bottom-36":
            !contentOnTop && gapOnBottom === "36",
        })}
        addId={id}
        gridGap="normal"
        padding={hasGridZeroPadding ? "zero" : "normal"}
      >
        {children.map((child, index) => {
          let {
            setLargeColumns,
            setMediumColumns,
            setLargeOffset,
            setMediumOffset,
          } = getColumnOffset(compact, children, index);
          return (
            <USBColumn
              layoutOpts={{
                spans: {
                  xlarge: setLargeColumns,
                  large: setLargeColumns,
                  medium: setMediumColumns,
                  small: 4,
                },
                offset: {
                  xlarge: setLargeOffset,
                  large: setLargeOffset,
                  medium: setMediumOffset,
                },
              }}
              {...otherProps}
            >
              <div
                className={classNames("usbobp-layout--children", {
                  "usbobp-layout--children-dir-column":
                    contentDirection === "column",
                  "usbobp-layout--children-rm-padding":
                    removeSpaceOf?.includes("padding"),
                  "usbobp-layout--children-rm-margin":
                    removeSpaceOf?.includes("margin"),
                })}
              >
                {child}
              </div>
            </USBColumn>
          );
        })}
      </USBGrid>
    );
  } else if (isMultiGrid) {
    return children.map((child, index) => {
      let {
        setLargeColumns,
        setMediumColumns,
        setLargeOffset,
        setMediumOffset,
      } = getColumnOffset(compact, children, index);
      return (
        <USBGrid
          addClasses={classNames(
            ...[
              "usbobp-layout--override-row-gap",
              "usbobp-layout--override-tb-padding",
            ]
          )}
          addContainerClasses={classNames({
            "usbobp-layout--page-header": actAsPageHeader && !contentOnTop,
            "usbobp-layout--page-footer": actAsPageFooter,
            "usbobp-layout--page-header-content-top":
              actAsPageHeader && contentOnTop,
            "usbobp-layout--card-first-child": actAsCardFirstChildd,
            "usbobp-layout--card-last-child": actAsCardLastChild,
            "usbobp-layout--card-middle-child": actAsCardMiddleChild,
            "usbobp-layout--remove-bottom-space": removeBottomSpace,
            "usbobp-layout--card-child": actAsCardChild,
            "usbobp-layout--shell": actAsShell,
            "usbobp-layout--shell-child": actAsShellChild,
            "usbobp-layout--thin-margin": showThinBottomMargin,
            "usbobp-layout--bottom-divider": showBottomDivider,
            "usbobp-layout--card-only-child": isOnlyCardChild,
            "usbobp-layout--mobile-top-margin": mobileTopMargin,
            "usbobp-layout--mobile-bottom-margin": mobileBottomMargin,
            // "usbobp-layout--desktop-topLeft-margin": desktopTopLeftMargin,
            "usbobp-layout--desktop-topLeft-margin-16":
              desktopTopLeftMargin === "16",
            "usbobp-layout--mobile-top-margin-24": mobileTopMargin === "24",
            "usbobp-layout--mobile-top-margin-10": mobileTopMargin === "10",
            "usbobp-layout--mobile-top-margin-8": mobileTopMargin === "8",
            "usbobp-layout--mobile-top-margin-0": mobileTopMargin === "0",
            "usbobp-layout--mobile-bottom-margin-24":
              mobileBottomMargin === "24",
            "usbobp-layout--mobile-bottom-margin-10":
              mobileBottomMargin === "10",
            "usbobp-layout--mobile-bottom-margin-8": mobileBottomMargin === "8",
            "usbobp-layout--mobile-bottom-margin-0": mobileBottomMargin === "0",
            // "usbobp-layout--color-theme-white": cardColorTheme === "white",
            "usbobp-layout--color-theme-gray": cardColorTheme === "gray",
            "usbobp-layout--gap-on-top-8": !contentOnTop && gapOnTop === "8",
            "usbobp-layout--gap-on-top-16": !contentOnTop && gapOnTop === "16",
            "usbobp-layout--gap-on-top-24": !contentOnTop && gapOnTop === "24",
            "usbobp-layout--gap-on-bottom-8":
              !contentOnTop && gapOnBottom === "8",
            "usbobp-layout--gap-on-bottom-16":
              !contentOnTop && gapOnBottom === "16",
            "usbobp-layout--gap-on-bottom-24":
              !contentOnTop && gapOnBottom === "24",
          })}
          addId={id}
          gridGap="normal"
          padding={hasGridZeroPadding ? "zero" : "normal"}
        >
          <USBColumn
            layoutOpts={{
              spans: {
                xlarge: setLargeColumns,
                large: setLargeColumns,
                medium: setMediumColumns,
                small: 4,
              },
              offset: {
                xlarge: setLargeOffset,
                large: setLargeOffset,
                medium: setMediumOffset,
              },
            }}
            {...otherProps}
          >
            <div
              className={classNames("usbobp-layout--children", {
                "usbobp-layout--children-dir-column":
                  contentDirection === "column",
                "usbobp-layout--children-rm-padding":
                  removeSpaceOf?.includes("padding"),
                "usbobp-layout--children-rm-margin":
                  removeSpaceOf?.includes("margin"),
              })}
            >
              {child}
            </div>
          </USBColumn>
        </USBGrid>
      );
    });
  }
};

function getColumnOffset(compact: any, children: any, index: any) {
  let setLargeColumns = compact ? 10 : 8;
  let setMediumColumns = 8;
  if (children.length === 2) {
    setLargeColumns = compact ? 5 : 4;
    setMediumColumns = 4;
  } else if (children.length === 3) {
    setLargeColumns = index === 1 ? (compact ? 4 : 2) : 3;
    setMediumColumns = index === 1 ? 2 : 3;
  }
  let setLargeOffset = compact ? 3 : 4;
  let setMediumOffset = 0;
  if (children.length === 2) {
    setLargeOffset = index === 1 ? 8 : compact ? 3 : 4;
  } else if (children.length === 3) {
    if (index === 1) {
      setLargeOffset = compact ? 6 : 7;
      setMediumOffset = 3
    } else if (index === 2) {
      setLargeOffset = compact ? 10 : 9;
      setMediumOffset = 5;
    }
  }
  return { setLargeColumns, setMediumColumns, setLargeOffset, setMediumOffset };
}

export default ShellGridColumn;
